import { useCallback, useEffect, useState } from 'react';
import { dashboardService } from '../services/dashboardService';
import { DashboardQueryParams } from '../types/dashboard.types';
import { MonthlySalesItem } from '../types/monthlySalesChart.types';

interface UseMonthlySalesReturn {
  data: MonthlySalesItem[] | null;
  loading: boolean;
  error: string | null;
}

/**
 * Hook to fetch monthly sales and leads data
 */
export const useMonthlySales = (params?: DashboardQueryParams): UseMonthlySalesReturn => {
  const [data, setData] = useState<MonthlySalesItem[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMonthlySales = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const monthlySummary = await dashboardService.getMonthlySummary(params);
      setData(monthlySummary as unknown as MonthlySalesItem[]);
    } catch (err: any) {
      setError(err?.message || 'Error fetching monthly sales data');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchMonthlySales();
  }, [fetchMonthlySales]);

  return { data, loading, error };
};
